export class SubTechnology {
    idSubTechnology: string
    name: string;
    technologyId: string;
  }
  